// extracted by mini-css-extract-plugin
export default {"primary":"#1890ff","success":"#3dcf46","warning":"#f59236","danger":"#f5222d"};